import type { HttpInterceptor } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const HTTP_AUTH_INTERCEPTOR = new InjectionToken<HttpInterceptor>(
  'HTTP_AUTH_INTERCEPTOR'
);
